<template>
  <div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6" style="padding: 70px 0px;">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack">{{$t('ep_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack">{{$t('ep_desc')}}</p>
            </div>
            <div class="col-md-6" style="text-align: center;">
              <img src="../../assets/imgs/singin_man.png" class="pman" />
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" style="margin-top: 40px;">
          <div class="col-md-3">
            <app-e-engineer-sidenav :selectedItem="selectedItem"></app-e-engineer-sidenav>
          </div>
          <div class="col-md-9">

            <div class="page_title">
              <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('usage_guide')}}</span>
            </div>
            <div class="row slide_options">
                <p class="cs_summary mplus2p-m spacing1-2 noiseblack" style="height:auto;white-space:pre-wrap;">{{$t('usage_guide_title1')}}</p>
                <p class="cs_summary mplus2p-m spacing1-2 noiseblack" style="width:100%;height:auto;">{{$t('usage_guide_title2')}}
                </p>
                <br>
                <ul >
                  <div v-for="(item, index) in usageGuide" :key="index">
                      <li v-if="lan == 'en' && item.en_file_name != null"><a :href="item.en_path" target="_blank" download >{{item.en_file_name}}</a></li>
                      <li v-if="lan == 'jp' && item.jp_file_name != null"><a :href="item.jp_path" target="_blank" download >{{item.jp_file_name}}</a></li>
                  </div>
                  <!-- <li v-for="(item, index) in usageGuide" :key="index">
                    <a v-if="lan == 'en' && item.en_file_name != null" :href="item.en_path" target="_blank" download >{{item.en_file_name}}</a>
                    <a v-if="lan == 'jp' && item.jp_file_name != null" :href="item.jp_path" target="_blank" download >{{item.jp_file_name}}</a>
                  </li> -->
                </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import e_engineer_sidenav from "./e_engineer_sidenav";
import { EventBus } from "../../main.js";

export default {
  data() {
    return {
      selectedItem: 91,
      usageGuide: [],
      JpUrl: '',
      lan: "jp"
    };
  },
  components: {
    appEEngineerSidenav: e_engineer_sidenav,
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    this.getUsagGuide();
  },
  mounted() {
    this.doCenter();
    EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  computed: {
    onResize(event) {
      this.doCenter();
    },
  },
  methods: {
    getUsagGuide(){
      axios
        .get("/usage-guide", {
          headers: { "X-localization": localStorage.getItem("lan"), }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            this.loading = false;
          } else {
            this.usageGuide = res.data.usage_guide;
          }
        })
        .catch(error => console.log(error));
    },
    doCenter() {
      let txtheight, txtwidth;
      if ($(window).width() <= 975 && $(window).width() >= 751) {
        $("#total").css("font-size", "1rem");
        $("#technical").css("font-size", "1rem");
        $("#management").css("font-size", "1rem");
        $("#business").css("font-size", "1rem");
        txtwidth = [10.44, 20.88, 31.3];
        txtheight = 40;
      } else {
        $("#total").css("font-size", "1.5rem");
        $("#technical").css("font-size", "1.5rem");
        $("#management").css("font-size", "1.5rem");
        $("#business").css("font-size", "1.5rem");
        txtwidth = [15.66, 31.3, 46.95];
        txtheight = 28;
      }
    },
  
  }
};
</script>

<style scoped>
.skillUpdate {
  padding-top: 10px;
  padding-bottom: 20px;
}

.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
  border: 2px solid #3d7dd8;
  font-size: 0.7rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #3d7dd8;
  padding: 5px;
  margin-right: 5px;
  white-space: pre;
  word-break: keep-all;
  display: inline-block;
  border-radius: 5px;
  margin-bottom: 10px;
}

.sub-layer2 {
  width: fit-content;
  background-color: #3d7dd8;
  font-size: 0.7rem;
  text-align: center;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.4px;
  color: #fff;
  padding: 8px;
  margin-right: 5px;
  margin-bottom: 10px;
  border-radius: 50px;
  display: block;
}

/* .tech {
    margin-right: 5px;
    margin-bottom: 20px;
    margin-top: 20px;
    display: inline-block;
  }
  .layer {
    border: 1px solid #3d7dd8;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 1.4px;
    color: #3d7dd8;
    padding: 14px;
    margin-right: 5px;
    margin-bottom: 10px;
    border-radius: 5px;
  }
  .layer::after {
    margin-left: 10px;
    color: #6474847d;
    top: 0;
    content: normal;
    border: 3px solid red;
  }
  .sub-layer {
    background-color: #3d7dd8;
    font-size: 18px;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 1.4px;
    color: #fff;
    padding: 14px;
    margin-right: 5px;
    margin-bottom: 10px;
    border-radius: 50px;
  } */
.pman {
  width: 120px;
  margin-top: 70px;
}

.slide_options {
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
  padding-left: 15px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 35px;
  max-width: 200px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  height: 50px;
  margin-bottom: 0.1rem;
}
.cline {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.statusnum {
  top: 55%;
  font-weight: bold;
  font-size: 3rem !important;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.custom-wrapper {
  /* width: 423px; */
  max-height: 250px;
  overflow: auto;
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }
}
</style>
